import React, { Component } from 'react';
import _ from 'lodash';
import './ProjectsList.css';
import Project from './Project/Project';
import { ToastContainer, toast } from 'react-toastify';
import AddNewProjectButton from '../AddNewProjectButton/AddNewProjectButton';
import AddNewProjectModal from '../AddNewProjectModal/AddNewProjectModal';

class ProjectsList extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            data: [],
            newDataChanged: false,
            typeOfSorting: 'asc',
            step1: true,
            projectDeleted: false,
            projectDublicated: false,
            addProjectModal: false,
            projectChallengesToggle: null
        };
    }

    openModal = () => {
        this.setState({addProjectModal : !this.state.addProjectModal});
    }

    openProjectChallenges = (id) => {
        if(this.state.projectChallengesToggle !== id){
            this.setState({ projectChallengesToggle : id });
        } else {
            this.setState({ projectChallengesToggle : false });
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.setState({ data: this.props.projectsList.Items });
    }

    componentWillReceiveProps(nextProps) {
        if (_.isEmpty(this.state.data) && (this.props.projectsList.Items !== nextProps.projectsList.Items)) {
            this.setState({ data: nextProps.projectsList.Items });
        }

        if ( !this.state.newDataChanged && (this.props.projectsList.Items !== nextProps.projectsList.Items)) {
            this.setState({ data: nextProps.projectsList.Items, newDataChanged : true });
        }

        if (nextProps.deleteData.statusCode === 200 && !this.state.projectDeleted) {
            this.setState({ projectDeleted: true, data: [] });
            toast.success(nextProps.deleteData.message)
            setTimeout(() => {
                this.props.resetDeleteProject();
            }, 5000);
            this.props.getProjectsList();
        }


        if (nextProps.dublicateData.statusCode === 200 && !this.state.projectDublicated) {
            this.setState({ projectDublicated: true, data: [] });
            toast.success(nextProps.dublicateData.message)
            //toast.success(nextProps.deleteData)
            this.props.getProjectsList();
        }

        if (nextProps.createdProjectData.statusCode && !this.props.projectAddedForParens) {
            this.setState({ data: [], })
            toast.success(nextProps.createdProjectData.message)
            setTimeout(() => {
                this.props.resetCreateProject();
            }, 5000);

            this.props.getProjectsList();
        }

    }

    projectDeleted = () => {
        this.setState({ projectDeleted: false });
    }

    onSort = (type, name) => {
        const data = this.props.projectsList.Items;
        let newData = _.orderBy(data, [name], [type]);
        this.setState({ data: newData, typeOfSorting: this.state.typeOfSorting === 'asc' ? 'desc' : 'asc', step1: false })
    }

    render() {
        var newdata = this.state.data;
        let projectsList = _.map(newdata, (value, index) => {
            return (
                <Project
                    key={index}
                    deleteProject={this.props.deleteProject}
                    projectData={value}
                    projectFullData={newdata}
                    dublicateProject={this.props.dublicateProject}
                    dublicateData={this.props.dublicateData}
                    getProjectsList={this.props.getProjectsList}
                    projectDeleted={this.projectDeleted}
                    toolkitsValidation={this.props.toolkitsValidation}
                    toolkitDataChanged={this.props.toolkitDataChanged}
                    toolkitValidationType={this.props.toolkitValidationType}
                    projectId={this.props.projectId}
                    projectChallengesToggle={this.state.projectChallengesToggle}
                    openProjectChallenges={this.openProjectChallenges}
                />
            )

        });

        return (
            <div>
                {!this.props.fetching &&
                    <div className="">
                        {(this.props.projectsList.Items && this.props.projectsList.Items.length > 0)    ?
                            <div className="table-component">
                                <div className='table-header'>
                                    <div className="table-header-col">
                                        <div className="table-sort-box" onClick={() => this.onSort  (this.state.typeOfSorting, 'projectName')}>
                                            {this.state.step1 ? '' : this.state.typeOfSorting === 'desc' ?
                                                 <i className="fas fa-caret-down" id="down1"></i>
                                                 :
                                                 <i className="fas fa-caret-up" id="up1"></i>
                                            }
                                            {this.state.step1 && <i className="fas fa-sort"></i>}
                                            <p>Project Name</p>
                                        </div>
                                    </div>
                                    <div className="table-header-col">
                                        <div className="table-sort-box sortbox2" onClick={() => this.onSort(this.state.typeOfSorting, 'updated_at')}>
                                            {this.state.step1 ? '' : this.state.typeOfSorting === 'desc' ?
                                                <i className="fas fa-caret-down" id="down2"></i>
                                                 :
                                                 <i className="fas fa-caret-up" id="up2"></i>
                                             }
                                            {this.state.step1 && <i className="fas fa-sort"></i>}
                                            <p>Date Modified</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-body">
                                    {projectsList}
                                </div>
                            </div>
                            :
                            <div className="empty-tool-list">
                                <h5 className='empty-table-test'>Please Add your your first Project</h5>
                                <AddNewProjectButton
                                    openModal={this.openModal}
                                    addProjectModal={this.state.addProjectModal}
                                    addedNewProjectState={this.props.addedNewProjectState}
                                />
                                { this.state.addProjectModal &&
                                    <AddNewProjectModal
                                        openModal={this.openModal}
                                        addProjectModal={this.state.addProjectModal}
                                        createProject={this.props.createProject}
                                        createdProjectFetching={this.props.createdProjectFetching}
                                        createdProjectData={this.props.createdProjectData}
                                        getProjectsList={this.props.getProjectsList}
                                        addedNewProjectState={this.props.addedNewProjectState}
                                    />
                                }
                            </div>
                        }
                        
                    </div>
                   
                }

                {this.props.fetching &&
                    <div>
                        {this.elementInfiniteLoad()}
                    </div>
                }

            </div>
        )
    }
}

export default (ProjectsList);



// WEBPACK FOOTER //
// ./src/components/Toolkit/ProjectsList/ProjectsList.jsx